import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { makeTeam as makeApiTeam } from '../../../api-calls/teams'
import { deleteTeam as deleteApiTeam } from '../../../api-calls/teams'

import { Dropdown, Menu, Icon, message, Popconfirm } from 'antd'

@observer(["ViewStore", "UserStore", "CategoriesStore", "LeagueStore", "web3Store", "AuthStore", "TeamStore"])
class ManageTeams extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bytes32Id: '',
            teamName: '',
            categoryId: '',
            categoryName: '',
            leagueId: '',
            leagueName: '',
            logoUrl: '',
            abbreviation: '',
            color: '',
            colors: [{ color: '' }],
            apiId: '',
        };
        this.handleTeamNameChange = this.handleTeamNameChange.bind(this);
        this.handleLogoUrlChange = this.handleLogoUrlChange.bind(this);
        this.handleAbbreviationChange = this.handleAbbreviationChange.bind(this);
        this.onCategoryClick = this.onCategoryClick.bind(this);
        this.onLeagueClick = this.onLeagueClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
        this.handleApiIdChange = this.handleApiIdChange.bind(this);
        this.handleColorsChange = this.handleColorsChange.bind(this);
        this.handleAddColor = this.handleAddColor.bind(this);
        this.handleRemoveColor = this.handleRemoveColor.bind(this);
    }

    async componentWillMount() {
        const { CategoriesStore } = this.props;

        CategoriesStore.queryCategories()
    }

    handleSubmit = (evt) => {
        const { web3Store, AuthStore, TeamStore } = this.props;

        let teamName = this.state.teamName;
        let category = this.state.categoryId;
        let league = this.state.leagueId;
        let logoUrl = this.state.logoUrl;
        let apiId = this.state.apiId;
        let abbreviation = this.state.abbreviation;
        let color = this.state.color;
        let firstSpaceIndex = teamName.indexOf(" ");
        let teamNameMinusCity = teamName.slice(firstSpaceIndex);
        let teamNameNoSpace = teamNameMinusCity.split(' ').join('')
        const teamBytes32Id = web3Store.web3.utils.padRight(web3Store.web3.utils.fromAscii(abbreviation + teamNameNoSpace), 34);
        //const teamBytes32Id = web3Store.web3.utils.padRight(web3Store.web3.utils.fromAscii("tormapleleafs"), 34);
        //web3.padRight(web3.fromAscii('abvglkjhn'), 34)
        const authToken = AuthStore.userAuth.auth.accessToken;

        let cleanColorList = []
        const results = this.state.colors.map((color) => { color.color !== "" ? cleanColorList.push(color.color) : null });

        console.log('teamName :' + teamName + '   category :' + category + '   league :' + league + '   logoUrl :' + logoUrl + '   teamBytes32Id :' + teamBytes32Id);

        Promise.all(results).then(() => makeApiTeam(
            authToken,
            teamBytes32Id,
            teamName,
            category,
            league,
            logoUrl,
            abbreviation,
            cleanColorList,
            apiId
        ).then(() => {
            message.success('Team Added!');
        }).then(() => {
            this.setState({
                teamName: '',
                categoryId: '',
                leagueId: '',
                logoUrl: '',
                categoryName: '',
                leagueName: '',
                abbreviation: '',
                colors: [{ color: '' }],
                apiId: ''
            });
        }));

    }

    handleTeamNameChange = (e) => {
        this.setState({ teamName: e.target.value });
    }

    handleLogoUrlChange = (e) => {
        this.setState({ logoUrl: e.target.value });
    }

    handleAbbreviationChange = (e) => {
        this.setState({ abbreviation: e.target.value });
    }

    handleApiIdChange(e) {
        this.setState({ apiId: e.target.value });        
    }

    renderCategoryMenu() {
        const { CategoriesStore } = this.props;
        let menuList = []

        CategoriesStore.categories.forEach(function (category) {
            menuList.push(<Menu.Item key={category._id}>
                <a target="_blank" rel="noopener noreferrer">{category.title}</a>
            </Menu.Item>);
        });

        return menuList;
    }

    onCategoryClick(key) {
        const { CategoriesStore, LeagueStore } = this.props;
        let self = this;

        CategoriesStore.categories.forEach(function (category) {
            if (category._id == key.key) {
                self.setState({
                    categoryId: category._id,
                    categoryName: category.title
                });
                LeagueStore.queryCategoryLeagues(category._id);
            }
        });
    }

    renderLeagueMenu() {
        const { LeagueStore } = this.props;
        let menuList = []

        LeagueStore.categoryLeagues.forEach(function (league) {
            menuList.push(<Menu.Item key={league._id}>
                <a target="_blank" rel="noopener noreferrer">{league.title}</a>
            </Menu.Item>);
        });

        return menuList;
    }

    onLeagueClick(key) {
        const { LeagueStore } = this.props;
        let self = this;

        LeagueStore.categoryLeagues.forEach(function (league) {
            if (league._id == key.key) {
                self.setState({
                    leagueId: league._id,
                    leagueName: league.title
                });
            }
        });
    }

    renderTeamDeleteList() {
        const { TeamStore } = this.props;

        let teamList = []
        let teams = Array.from(TeamStore.teams.values());

        for (let team of teams) {
            teamList.push(
                <div className="admin-delete-table" key={team._id}>
                    <div className="admin-delete-table-column-title-logo">
                        <img src={team.logoUrl} width="20" />
                        <span>{team.name}</span>
                    </div>
                    <div>
                        <Popconfirm title={"Sure you want to delete " + team.name + "?"} onConfirm={() => { this.onClickDelete(team._id) }} okText="Yes" cancelText="No">
                            <button className="custom-btn-danger"><Icon type="delete" /></button>
                        </Popconfirm>

                    </div>
                </div>
            )
        }
        return teamList;
    }

    onClickDelete(teamId) {
        const { AuthStore, TeamStore } = this.props;
        const authToken = AuthStore.userAuth.auth.accessToken;

        console.log(teamId);

        return deleteApiTeam(
            authToken,
            teamId
        ).then(() => {
            message.success('Team Deleted!')
        }).then(() => {
            TeamStore.queryTeams();
        });
    }

    handleColorsChange = (idx) => (e) => {
        const newColors = this.state.colors.map((color, sidx) => {
            if (idx !== sidx) return color;
            return { ...color, color: e.target.value };
        });

        this.setState({ colors: newColors });
    }

    handleAddColor = () => {
        this.setState({
            colors: this.state.colors.concat([{ color: '' }])
        });
    }

    handleRemoveColor = (idx) => () => {
        this.setState({
            colors: this.state.colors.filter((s, sidx) => idx !== sidx)
        });
    }

    render() {
        return (
            <div className="admin-wrap">
                <h2>Add a Team</h2>
                <div className="admin-form">
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Title: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="Team Name"
                            value={this.state.teamName}
                            onChange={this.handleTeamNameChange}
                        />
                    </div>
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Logo URL: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="Team Logo URL"
                            value={this.state.logoUrl}
                            onChange={this.handleLogoUrlChange}
                        />
                    </div>
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Team Colors: </div>
                        {this.state.colors.map((color, idx) => (
                            <div className="PicUrl" key={idx}>
                                <input
                                    type="text"
                                    className="custom-input"
                                    style={{ width: '60%' }}
                                    placeholder={`Team Color #${idx + 1}`}
                                    value={color.color}
                                    onChange={this.handleColorsChange(idx)}
                                />
                                <button className="custom-btn-primary" type="button" onClick={this.handleRemoveColor(idx)}>-</button>
                                {this.state.colors.length == (idx + 1) ?
                                    <button className="custom-btn-primary" type="button" onClick={this.handleAddColor}>Add Field</button>
                                    :
                                    null
                                }
                            </div>
                        ))}
                    </div>
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Abbreviation: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="Team Abbreviation"
                            value={this.state.abbreviation}
                            onChange={this.handleAbbreviationChange}
                        />
                    </div>
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">API ID: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="API ID"
                            value={this.state.apiId}
                            onChange={this.handleApiIdChange}
                        />
                    </div>
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Category: </div>
                        <Dropdown overlay={<Menu onClick={this.onCategoryClick}>{this.renderCategoryMenu()}</Menu>}>
                            {this.state.categoryId !== "" ?
                                <a className="admin-form-field-dropdown-link" href="#">{this.state.categoryName} <Icon type="down" /></a>
                                :
                                <a className="admin-form-field-dropdown-link" href="#">Select a Category <Icon type="down" /></a>
                            }
                        </Dropdown>
                    </div>
                    {this.state.categoryId !== "" ?
                        <div className="admin-form-field">
                            <div className="admin-form-field-title">League: </div>
                            <Dropdown overlay={<Menu onClick={this.onLeagueClick}>{this.renderLeagueMenu()}</Menu>}>
                                {this.state.leagueId !== "" ?
                                    <a className="admin-form-field-dropdown-link" href="#">{this.state.leagueName} <Icon type="down" /></a>
                                    :
                                    <a className="admin-form-field-dropdown-link" href="#">Select a League <Icon type="down" /></a>
                                }
                            </Dropdown>
                        </div>
                        :
                        null
                    }
                </div>
                <div style={{ marginTop: '15px' }}>
                    <button onClick={this.handleSubmit} className="custom-btn-primary">Submit</button>
                </div>
                <br /><br /><br /><hr /><br /><br /><h1>Delete Teams</h1><br />
                <div>
                    {this.renderTeamDeleteList()}
                </div>
            </div>
        );
    }
}

export default ManageTeams;


// WEBPACK FOOTER //
// ./src/components/appComponents/admin/ManageTeams.js